import { Component, Input } from '@angular/core';
import { LocaleContent } from '@app/shared/data';

@Component({
  selector: 'app-rc-order-status',
  templateUrl: './rc-order-status.component.html',
  styleUrls: ['./rc-order-status.component.scss'],
  standalone: true,
})
export class RcOrderStatusComponent {
  @Input() localeContentStatus: LocaleContent;
}
